import { DEFAULT_DATE } from '../utilities/constants';
import { getValueFromLocalStorage } from '../utilities/utilityFunctions';
import { client, gql } from './Client';

const workPackageFilesQuery = gql`
  query workPackageFileDetailsFeed(
    $siteId: Int!
    $disciplineId: Int!
    $lastModified: DateTime!
    $isLeadInspector: Boolean!
  ) {
    workPackageFileDetailsFeed(
      siteId: $siteId
      disciplineId: $disciplineId
      lastModified: $lastModified
      isLeadInspector: $isLeadInspector
    ) {
      fileId
      workPackageId
      siteId
      disciplineId
    }
  }
`;

const workPackageFiles = (siteId: number, disciplineId: number) =>
  client.query({
    query: workPackageFilesQuery,
    variables: {
      siteId,
      disciplineId,
      lastModified: DEFAULT_DATE,
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  });

export { workPackageFiles };
